import React from "react";
import { ChevronRight } from "lucide-react";
import { TimecardEntry } from "../../../types/state/timecards";
import { formatHoursWithUnits } from "../../../utils/employeeTimeCardhelper";
import { DateTimeUtil } from "../../../utils";

type MobileTimesheetEntry = TimecardEntry & {
    other_details?: {
        DURATION_TYPE?: string;
        DISPLAY_STARTENDTIME?: string | number;
    };
    request_notes?: string;
};

export interface MobileTimesheetEntryRowProps {
    entry: MobileTimesheetEntry;
    rowClassName: string;
    onClick?: () => void;
    showChevron?: boolean;
}

const MobileTimesheetEntryRow: React.FC<MobileTimesheetEntryRowProps> = ({
    entry,
    rowClassName,
    onClick,
    showChevron = true,
}) => {
    console.log("Rendering MobileTimesheetEntryRow with entry:", entry.other_details);
    const isTimeOff = entry?.record_type === "T";
    const isAttendance = entry?.record_type === "A";
    const shouldShowHoursOnly =
        isAttendance &&
        (String(entry?.other_details?.DURATION_TYPE || "").toUpperCase() === "HOURS" ||
            String(entry?.other_details?.DISPLAY_STARTENDTIME ?? "") === "0" || entry?.other_details?.DISPLAY_STARTENDTIME === 0);
    const duration = formatHoursWithUnits(
        Number(entry?.hours) || 0,
        entry?.earning_code as { units?: string } | undefined,
    );
    const timeRange = `${DateTimeUtil.getFormattedTime(entry?.start_datetime || "", "Missing punch")} – ${DateTimeUtil.getFormattedTime(entry?.end_datetime || "", "Missing punch")}`;
    const earningCodeName = entry?.earning_code?.name || (isTimeOff ? "Time Off" : "Attendance");
    const primaryLabel = isTimeOff ? earningCodeName : shouldShowHoursOnly ? duration : timeRange;
    const secondaryItems = [
        !isTimeOff ? earningCodeName : null,
        // entry?.work_code?.name,
        // entry?.department?.name,
        // entry?.site?.name,
        // entry?.request_notes,
    ].filter(Boolean) as string[];

    return (
        <div
            className={`rounded-lg border border-gray-100 px-4 py-3 transition-colors duration-200 ${rowClassName}`}
            onClick={onClick}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                    <div className={`text-base font-medium ${isTimeOff ? "text-red-700" : "text-gray-900"}`}>
                        {primaryLabel}
                        {!shouldShowHoursOnly && (
                            <span className="ml-2 text-sm font-normal text-gray-500">({duration})</span>
                        )}
                    </div>
                    {secondaryItems.length > 0 && (
                        <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-gray-500">
                            {secondaryItems.map((item, index) => (
                                <React.Fragment key={`${item}-${index}`}>
                                    {index > 0 && <span aria-hidden>•</span>}
                                    <span className="truncate">{item}</span>
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                </div>
                {showChevron && isAttendance && (
                    <ChevronRight className="mt-0.5 shrink-0 text-gray-400" size={20} strokeWidth={1.5} />
                )}
            </div>
        </div>
    );
};

export default MobileTimesheetEntryRow;
